import { useMemo } from 'react';
import { LeadRecordSchema } from '@flashpoint/site-dna';
import type { StepProps } from '../stepProps';

export function ReviewStep({ lead }: StepProps) {
  const result = useMemo(() => LeadRecordSchema.safeParse(lead), [lead]);

  const printHref = `/leads/${lead.id}/print-options`;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-nm-border bg-nm-moss/30 p-3">
        <div className="text-xs text-nm-ink">
          Open a printable one-page summary of every choice in this wizard. Read it aloud during a
          discovery call, or print it as a leave-behind for the client.
        </div>
        <a
          href={printHref}
          target="_blank"
          rel="noreferrer"
          className="rounded-md border border-flashpoint-ember bg-flashpoint-ember/15 px-3 py-1.5 text-xs font-semibold text-flashpoint-ember hover:bg-flashpoint-ember/25"
        >
          Print option set
        </a>
      </div>

      {result.success ? (
        <div className="rounded-md border border-nm-success/30 bg-nm-success-bg p-3 text-xs text-nm-success">
          Lead record passes Site DNA v2 validation. You can hit "Done" to advance to provisioning
          (wired in Phase 4).
        </div>
      ) : (
        <div className="rounded-md border border-nm-danger/30 bg-nm-danger-bg p-3 text-xs text-nm-danger">
          <div className="font-semibold">Validation issues:</div>
          <ul className="mt-1 list-disc pl-4">
            {result.error.issues.map((issue, i) => (
              <li key={i}>
                <code className="font-mono">{issue.path.join('.')}</code>: {issue.message}
              </li>
            ))}
          </ul>
        </div>
      )}

      <details open className="rounded-lg border border-nm-border bg-nm-moss/30 p-3">
        <summary className="cursor-pointer text-sm font-semibold text-nm-ink">
          Lead record (full Site DNA + factory metadata)
        </summary>
        <pre className="mt-2 max-h-[60vh] overflow-auto rounded bg-nm-bg/60 p-3 text-[11px] text-nm-ink">
          {JSON.stringify(lead, null, 2)}
        </pre>
      </details>
    </div>
  );
}
